module.exports = __webpack_public_path__ + "img/songwriters-journal_B09MYVVSHQ.4c56199a.jpg";